// ContextRegistry.js
// Canonical home of the agent context registry (moved out of components/Misc/Synapse).
export class ContextRegistry {
  constructor() {
    // Store context objects in a Map keyed by context identifier.
    this.contexts = new Map();
  }

  /**
   * Adds or updates a context object.
   * If a context with the same ID exists, it will be replaced.
   * @param {string} contextId - A unique identifier for this context (e.g., 'current_patient')
   * @param {Object} contextData - The context data to store
   */
  addContext(contextId, contextData) {
    if (!contextId || typeof contextId !== 'string') {
      throw new Error('Context must have a valid string identifier');
    }
    this.contexts.set(contextId, contextData); // Replaces if already exists
  }

  /**
   * Removes a context by identifier.
   * @param {string} contextId - The context identifier
   */
  removeContext(contextId) {
    this.contexts.delete(contextId);
  }

  /**
   * Retrieves a context by identifier.
   */
  getContext(contextId) {
    return this.contexts.get(contextId);
  }

  /**
   * Returns all contexts as an object.
   */
  getAllContexts() {
    const allContexts = {};
    this.contexts.forEach((value, key) => {
      allContexts[key] = value;
    });
    return allContexts;
  }

  /**
   * Formats all contexts as a string for inclusion in system instructions.
   */
  getFormattedContext() {
    if (this.contexts.size === 0) {
      return '';
    }

    let contextString = '\n\n## Current Context\n';

    this.contexts.forEach((contextData, contextId) => {
      contextString += `\n### ${contextId}\n`;
      contextString += JSON.stringify(contextData, null, 2);
      contextString += '\n';
    });

    return contextString;
  }

  /**
   * Clears all contexts.
   */
  clearAll() {
    this.contexts.clear();
  }
}
